let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2F69B"), load("joJy8"), load("aHE9G"), load("gr3fi")]).then(() => parcelRequire('h595R'));